import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { useRealtimeDrivers } from 'Core/hooks';
import { Select, Button } from 'Components';
import { Grid, Typography } from '@mui/material';
import Checkbox from 'Components/Checkbox';
import { MenuComponent } from 'Components/Menu';
import TimeCardMesssageEdit from './components/createEdit';
import TimeCardDelete from './components/delete';
import InputDate from 'Components/InputDate';
import moment from 'moment';
import { Alert } from '@mui/material';
import './index.scss';
import Loading from 'Components/Loading';
import { GetFormatForMoment, formatTimeHour } from 'Core/data/Helpers';

import {
    searchTimeCard,
    openTimeCardCreateEdit,
    openTimeCardDelete
} from 'Redux/actions';

const TimeCard = (props) => {
    //const
    const { messages,locale } = useIntl();

    const dispatch = useDispatch();

    const [selectedRows, setSelectedRows] = useState([]);
    const [filter, setFilter] = useState('');
    const [error, setError] = useState('');
    const [totalDaily, setTotalDaily] = useState('');
    const [data, setData] = useState({});
    const [formData, setFormData] = useState({});
    const optionsAction = [{
        id: 'I',
        name: messages['FSM_SETTINGS_TIME_CARD_clockIn']
    }, {
        id: 'O',
        name: messages['FSM_SETTINGS_TIME_CARD_clockOut']
    },
    {
        id: 'BO',
        name: messages['FSM_SETTINGS_TIME_CARD_meakbegin']
    },
    {
        id: 'BI',
        name: messages['FSM_SETTINGS_TIME_CARD_meakEnd']
    }];

    //get the information for drivers from catalog
    const allDrivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });

    const TimeCardDrivers = useMemo(() => {
        return allDrivers?.filter(driver => driver.fsmDriver === true) || [];   
    }, [allDrivers]);
    const loadingTimeCard = useSelector(state => state.catalogsRedux.loadingDrivers);

    //Selectors
    const quickMData = useSelector(state => state.timeCardsRedux.quickMData);

    const { timeZone, dateformat } = useSelector(state => state.securityRedux.user);

    const formatDate = GetFormatForMoment(dateformat)


    const fsmNomadPushNotification = useSelector(state => state.catalogsRedux.fsmNomadPushNotification);

    useEffect(() => {
        if (fsmNomadPushNotification && fsmNomadPushNotification?.Entity === "nomadTimecard") {
            dispatch(searchTimeCard({
                startDate: convertDateUtc(`${moment(formData.dateTimeStart).format("YYYY-MM-DD")} 00:00:00`, timeZone),
                endDate: convertDateUtc(`${moment(formData.dateTimeEnd).format("YYYY-MM-DD")} 23:59:59`, timeZone),
                driverId: formData?.fsmDrivers?.driverId
            }, true));
        }
    }, [fsmNomadPushNotification]);

    useEffect(() => {
        if (quickMData?.length) {
            let dataResponse = quickMData.slice().sort((a, b) => (a.date > b.date) ? 1 : -1)
            let response = {};
            let totalDay = 0;
            dataResponse.forEach((item) => {
                if (item.type !== 'preview') {                
                    let dateFormat = dateFromatUtf(item?.date)

                    if (!response[dateFormat]) {
                        response[dateFormat] = {
                            data: [],
                            total: 0
                        }
                    }

                    if (optionsAction[0]?.id === item.action || optionsAction[1]?.id === item.action) {
                        let nextOut = dataResponse.filter((filter) => {
                            if (optionsAction[0]?.id === item.action && new Date(filter.date) > new Date(item.date) && optionsAction[1]?.id === filter.action || optionsAction[1]?.id === item.action && new Date(filter.date) < new Date(item.date) && optionsAction[0]?.id === filter.action)
                                return true

                            return false;
                        });

                        
                        if (nextOut.length > 0) {
                            let total = 0
                            let nextOutFormat = dateFromatUtf(nextOut[0].date)

                            if(optionsAction[0]?.id === item.action &&  moment(dateFormat).endOf('day') <  new Date(nextOutFormat) ){
                                total = moment(moment(dateFormat).endOf('day').format('YYYY-MM-DD HH:mm:ss')).diff(item.date, 'seconds');
                            }else if(optionsAction[1]?.id === item.action){
                                let newDate = (moment(dateFormat).startOf('day') >  new Date(nextOut[nextOut.length - 1].date))?moment(dateFormat).startOf('day').format('YYYY-MM-DD HH:mm:ss'):nextOut[nextOut.length - 1].date
                                total = moment(item.date).diff(newDate, 'seconds');

                            }
                            response[dateFormat].total += total;
                            totalDay += total;
                        }
                    }else if(optionsAction[2]?.id === item.action ){

                        let nextOut = dataResponse.filter((filter) => {
                            if (optionsAction[3]?.id === filter.action  && new Date(filter.date) > new Date(item.date))
                                return true

                            return false;
                        });


                        if (nextOut.length > 0 && response[dateFormat]?.data?.length > 0) {
                            let newDate = (moment(dateFormat).startOf('day') >  new Date(nextOut[0].date))?moment(dateFormat).startOf('day').format('YYYY-MM-DD HH:mm:ss'):nextOut[0].date
                            let total = moment(newDate).diff(item.date, 'seconds');
                            response[dateFormat].total -= total;
                            totalDay -= total;
                        }
                    }

                    response[dateFormat].data.push(item);
                }

            });
            setTotalDaily(totalDay)
            setData(response)
        }
    }, [quickMData]);


    useEffect(() => {

        if (formData?.dateTimeStart && formData?.dateTimeEnd && formData?.fsmDrivers) {
            setData({});
            setFilter('');
            setSelectedRows([])
            dispatch(searchTimeCard({
                startDate: convertDateUtc(`${moment(formData.dateTimeStart).format("YYYY-MM-DD")} 00:00:00`, timeZone),
                endDate: convertDateUtc(`${moment(formData.dateTimeEnd).format("YYYY-MM-DD")} 23:59:59`, timeZone),
                driverId: formData?.fsmDrivers?.driverId
            }));
        }
    }, [formData]);


    useEffect(() => {
        if (TimeCardDrivers?.length > 0) {
            setFormData({
                dateTimeStart: moment().subtract(1, 'month')._d,
                dateTimeEnd: new Date(),
                fsmDrivers: TimeCardDrivers[0]
            });
        }
    }, [TimeCardDrivers]);

    const convertDateUtc = (value, timeZone) => {
        let date = moment(value).format("YYYY-MM-DD HH:mm:ss")
        let m = moment.tz(date, timeZone);
        date = m.tz("UTC").format('YYYY-MM-DD HH:mm');

        return date
    };



    const dateFromatUtf = (date)=>{
        let dateNew = new Date(new Date(date).toISOString().slice(0, -1));
        dateNew = moment(dateNew).format('YYYY-MM-DD HH:mm:ss')
        let utcCutoff = moment.utc(dateNew, 'YYYY-MM-DD HH:mm:ss');
        return utcCutoff.clone().tz(timeZone).format('YYYY-MM-DD')
    }

    const callBack = useCallback(() => {
        setFormData({ ...formData, dateTimeEnd: new Date() })
        setFilter('');
        setSelectedRows([])
        dispatch(searchTimeCard({
            startDate: convertDateUtc(`${moment(formData.dateTimeStart).format("YYYY-MM-DD")} 00:00:00`, timeZone),
            endDate: convertDateUtc(`${moment(formData.dateTimeEnd).format("YYYY-MM-DD")} 23:59:59`, timeZone),
            driverId: formData?.fsmDrivers?.driverId
        }));

    });

    return (
        <div>
            {
                error &&
                <Alert severity="error" onClose={() => setError('')}>{error}</Alert>
            }
            <Grid container spacing={0} className="timeCardFilterContainer">

                <Grid item sm={12}>
                    <InputDate
                        id="dateTimeStart"
                        label={messages['FSM_SETTINGS_TIME_CARD_startDate']}
                        value={formData.dateTimeStart}
                        onChange={(value) => {
                            if (value > formData.dateTimeEnd) {
                                setError(messages['FSM_SETTINGS_TIME_CARD_error_date'])
                            } else {
                                setFormData({ ...formData, dateTimeStart: value })
                            }
                        }}
                        type='date'
                        style={{ paddingTop: 0 }}
                        disabled={loadingTimeCard}
                        max={new Date()}
                        direction="row"
                        required
                    />
                </Grid>
                <Grid item sm={12}>
                    <InputDate
                        id="dateTimeEnd"
                        label={messages['FSM_SETTINGS_TIME_CARD_endDate']}
                        value={formData.dateTimeEnd}
                        onChange={(value) => {
                            if (value < formData.dateTimeStart) {
                                setError(messages['FSM_SETTINGS_TIME_CARD_error_date'])
                            } else {
                                setFormData({ ...formData, dateTimeEnd: value })
                            }
                        }}
                        type='date'
                        style={{ paddingTop: 0 }}
                        disabled={loadingTimeCard}
                        max={new Date()}
                        direction="row"
                        required
                    />
                </Grid>
                <Grid item sm={12}>
                    <Select
                        id="driverFilter"
                        label={messages['FSM_SETTINGS_TIME_CARD_driver']}
                        value={formData.fsmDrivers}
                        onChange={(value) => setFormData({ ...formData, fsmDrivers: value })}
                        options={TimeCardDrivers}
                        textField="name"
                        valueField="driverId"
                        menuPlacement="auto"
                    />
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                style={{ paddingTop: 10 }}
            >
                <Grid item xs>
                    <Button
                        type="icon"
                        icon="add_box"
                        tooltip={messages['add']}
                        disabled={!formData?.fsmDrivers?.driverId || !formData?.dateTimeStart || !formData?.dateTimeEnd}
                        onClick={() => {
                            dispatch(openTimeCardCreateEdit(true, {
                                ...formData
                            }))
                        }}
                    />
                    <Button
                        type="icon"
                        icon="delete"
                        disabled={!selectedRows?.length}
                        tooltip={messages['delete']}
                        onClick={() => {
                            dispatch(openTimeCardDelete(true, selectedRows))
                        }}
                    />
                </Grid>
                <Grid item xs className='text-right'>
                    {
                        data?.length > 0 &&
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                        >
                            <Grid item>
                                <Checkbox
                                    id={'time-cards-form-select-all'}
                                    value={data?.length === selectedRows.length}
                                    className='allSelection-checkbox'
                                    onChange={(checked) => {
                                        if (checked) {
                                            setSelectedRows(data);
                                        } else {
                                            setSelectedRows([]);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <Button
                                    className="btn-cancel btn-sm"
                                    style={{
                                        color: '#333333'
                                    }}
                                    onClick={(e) => {
                                        if (e) e.preventDefault();
                                        if (selectedRows?.length === data?.length) {
                                            setSelectedRows([]);
                                        } else {
                                            setSelectedRows(data);
                                        }

                                    }}
                                >
                                    {messages['fsm_settings_form_selectAll']}
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>
            <div
                style={{
                    height: "calc(100vh - 520px)",
                    overflow: "auto"
                }}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >
                    {loadingTimeCard &&
                        <Loading full />
                    }

                    {
                        data && Object.keys(data)?.map((row) => {
                            return (
                                <>
                                    <Grid container direction="row"  style={{width:'100%',padding:10}}>
                                        <Grid item sm={5}><h4>{moment(row).locale(locale).format('MMMM D, YYYY')}</h4></Grid>
                                        <Grid item sm={7} style={{textAlign:'right'}}><h4>{messages['FSM_SETTINGS_TIME_CARD_daily_total']} : {formatTimeHour(data[row]?.total, messages)}</h4></Grid>
                                    </Grid>


                                    {
                                        data[row]?.data?.length > 0 && data[row]?.data?.map((item, index) => {
                                            let selected = selectedRows.find(selectedRow => selectedRow.id === item.id);
                                            let action = optionsAction.filter(actions => actions.id === item?.action)[0].name;
                                            let dateFormat = new Date(new Date(item?.date).toISOString().slice(0, -1));
                                            dateFormat = moment(dateFormat).format('YYYY-MM-DD HH:mm:ss')
                                            let utcCutoff = moment.utc(dateFormat, 'YYYY-MM-DD HH:mm:ss');
                                            let displayCutoff = utcCutoff.clone().tz(timeZone);

                                            return (
                                                <Grid
                                                    key={index}
                                                    item xs
                                                    style={{ width: '100%', margin: 0 }}
                                                >
                                                    <div style={{ padding: '5px 4px 8px 3px' }}>
                                                        <div className={"TimeCardView-card TimeCardView-container"}>
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="flex-start"
                                                                alignItems="center"
                                                            >
                                                                <Grid item>
                                                                    <Checkbox
                                                                        id={`fsm-time-${item?.id}`}
                                                                        value={selected ? true : false}
                                                                        className='label-no-margin'
                                                                        size="sm"
                                                                        onChange={(checked) => {

                                                                            let newSelectedRows = [];
                                                                            if (checked) {
                                                                                newSelectedRows = [...selectedRows];
                                                                                newSelectedRows.push(item);
                                                                            } else {
                                                                                newSelectedRows = selectedRows.filter(selectedRow => selectedRow.id !== item.id);
                                                                            }

                                                                            setSelectedRows([...newSelectedRows]);
                                                                        }}
                                                                    ></Checkbox>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Typography
                                                                        noWrap
                                                                        variant="subtitle1"
                                                                        className="formSetting-title"
                                                                    >
                                                                        {action}
                                                                    </Typography >
                                                                </Grid>
                                                                <Grid item >
                                                                    <MenuComponent
                                                                        icon={'more_vert'}
                                                                        options={[
                                                                            messages['edit'],
                                                                            messages['delete']
                                                                        ]}
                                                                        className="formSetting-actions icon-menu-vehicle-service showInHover"
                                                                        onClick={(type) => {
                                                                            if (type === messages['edit']) {
                                                                                dispatch(openTimeCardCreateEdit(true, {
                                                                                    ...formData,
                                                                                    ...item,
                                                                                    date: displayCutoff.format('YYYY-MM-DD HH:mm')
                                                                                }))
                                                                            } else {
                                                                                dispatch(openTimeCardDelete(true, [item]))

                                                                            }
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <Grid
                                                                container
                                                                direction="row"
                                                                justifyContent="flex-start"
                                                                alignItems="center"
                                                            >
                                                                <Grid item>
                                                                    <Typography noWrap variant="subtitle2" color={'textSecondary'} style={{ float: 'left', marginLeft: 3, marginRight: 10 }}>
                                                                        {messages['FSM_SETTINGS_TIME_CARD_date']}:
                                                                    </Typography>
                                                                    {displayCutoff.format(`${formatDate} hh:mm A`)}
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            )
                                        })
                                    }

                                </>
                            )
                        })
                    }

                    {totalDaily > 0 && 
                            <Grid container direction="row"  style={{width:'100%',padding:10}}>
                               <Grid item sm={4}></Grid>
                               <Grid item sm={8} style={{textAlign:'right'}}><h3> {messages['FSM_SETTINGS_TIME_CARD_total']} : {formatTimeHour(totalDaily, messages) } </h3> </Grid>
                           </Grid>
                    }
                </Grid>
            </div>

            <TimeCardMesssageEdit callBack={callBack} />
            <TimeCardDelete callBack={callBack} />
        </div>
    );
}

export default TimeCard;